export default "__VITE_ASSET__BxKqOgJc__"